var _path, _path2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 147,
    viewBox: "0 0 120 147",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "security-1",
    d: "M120 132.178C120 140.364 93.1371 147 60 147C26.8629 147 3.05176e-05 140.364 3.05176e-05 132.178C3.05176e-05 123.992 26.8629 117.355 60 117.355C93.1371 117.355 120 123.992 120 132.178Z",
    fill: "#313234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "security-2",
    d: "M0 133 H120 V94 H0 Z",
    fill: "#313234"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security-3-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "security-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.94 79.6483C110.94 86.6337 88.0343 92.2966 59.7793 92.2966C31.5243 92.2966 8.61914 86.6337 8.61914 79.6483C8.61914 72.6628 31.5243 67 59.7793 67C88.0343 67 110.94 72.6628 110.94 79.6483Z",
    fill: "#6B6D71"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "security-4-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "security-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.541 77.4744C102.541 83.2592 83.5937 87.9487 60.2208 87.9487C36.8479 87.9487 17.9004 83.2592 17.9004 77.4744C17.9004 71.6895 36.8479 67 60.2208 67C83.5937 67 102.541 71.6895 102.541 77.4744Z",
    fill: "#9DA0A4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "security-5-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "security-5",
    d: "M93.4808 75.3004C93.4808 79.8846 78.491 83.6009 60.0002 83.6009C41.5093 83.6009 26.5195 79.8846 26.5195 75.3004C26.5195 70.7162 41.5093 67 60.0002 67C78.491 67 93.4808 70.7162 93.4808 75.3004Z",
    fill: "#E3E3E3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "security-6-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "security-6",
    d: "M120 14.8222C120 23.0083 93.137 29.6444 60 29.6444C26.8629 29.6444 0 23.0083 0 14.8222C0 6.63612 26.8629 0 60 0C93.137 0 120 6.63612 120 14.8222Z",
    fill: "#37383B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.7dd31856cb597714d73b8ac45faaf1c1.svg";
export { ForwardRef as ReactComponent };